<template>
  <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <template v-for="(items,index) in navs">
           <el-breadcrumb-item :to="items.path?items.path:'/'" :key="index">{{items.name}}</el-breadcrumb-item>
        </template>
        <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>活动管理</el-breadcrumb-item>
        <el-breadcrumb-item>活动列表</el-breadcrumb-item>
        <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
      </el-breadcrumb>
  </div>
</template>

<script>

export default {
  name: "AppNav",
  
  data() {
    return {
      navs: []
    };
  },
  
  methods: {
    fetchData() {
      const list = this.$route.matched;
      // console.log("list", list);
      this.navs = list;
    }
  },
  
  created() {
    this.fetchData();
  },
  
  watch: {
    $route: {
      handler() {
        this.fetchData();
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
